import { Routes } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { organizationsRoutes } from '@routes/guides/organization';
import { sportTypesRoutes } from '@routes/guides/sport-types';
import { competitionsRoutes } from '@routes/guides/competitions';
import { okrugsRoutes } from '@routes/guides/okrugs';
import { regionsRoutes } from '@routes/guides/regions';
import { usersRoutes } from '@routes/guides/users';
import { textBlocksRoutes } from '@routes/guides/text-blocks';
import { regulationsRoutes } from '@routes/guides/regulations';
import { approversRoutes } from '@routes/guides/approvers';

const childRoutes: Routes = [
    {
        path: 'access-denied',
        loadComponent: () =>
            import('@pages/access-denied/access-denied').then((m) => m.AccessDenied),
        data: {
            searchString: false,
        },
    },
    {
        path: '',
        title: 'PRSS',
        loadComponent: () => import('@pages/main/main.component').then((m) => m.MainComponent),
        data: {
            searchString: false,
        },
    },
    {
        path: 'settings',
        title: 'PRSS',
        loadComponent: () =>
            import('../pages/settings/settings.component').then((m) => m.SettingsComponent),
        data: {
            breadcrumbs: [{ name: 'Настройки', url: '/settings' }],
            searchString: false,
        },
    },
    ...competitionsRoutes,
    ...okrugsRoutes,
    ...regionsRoutes,
    ...organizationsRoutes,
    ...sportTypesRoutes,
    ...usersRoutes,
    ...textBlocksRoutes,
    ...regulationsRoutes,
    ...approversRoutes,
    {
        path: '**',
        loadComponent: () => import('@pages/page-404/page-404').then((c) => c.Page404),
        data: {
            searchString: false,
        },
    },
];

export const routes: Routes = [
    {
        path: 'frontchannel-logout',
        loadComponent: () =>
            import('@pages/frontchannel-logout/frontchannel-logout')
                .then((m) => m.FrontchannelLogout),
    },
    {
        path: '',
        loadComponent: () => import('@layout/layout-prss/layout-prss').then((c) => c.LayoutPrss),
        children: childRoutes,
        canActivate: [authGuard],
    },
];
